import '@fontsource-variable/big-shoulders'
import '@fontsource-variable/archivo'
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'
import './app.css'
import App from './v2/AppShell.svelte'
import { initTelemetry, reportFatal } from './lib/telemetry'
import { initSentry } from './lib/sentry'

// Telemetry first: a crash during mount must still be captured and reported
// (specs/observability). Sentry is a DSN-gated no-op until configured.
initTelemetry()
initSentry()

let app: App | null = null
try {
  app = new App({
    target: document.getElementById('app')!,
  })
} catch (err) {
  // Nothing else can render now — show a plain-HTML screen with the
  // diagnostics code instead of a white page.
  const code = reportFatal(err)
  document.getElementById('app')!.innerHTML = `
    <div style="min-height:60vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;font-family:'Space Mono',monospace;text-align:center;padding:24px;">
      <p style="margin:0;">something broke while loading.</p>
      <p style="margin:0;">tell us this code: <strong style="letter-spacing:0.15em;">${code}</strong></p>
      <button style="width:auto;margin-top:12px;padding:8px 16px;cursor:pointer;" onclick="window.location.reload()">try again</button>
    </div>`
  throw err
}

const handleGestureStart = (event: Event) => {
  event.preventDefault()
}

document.addEventListener('gesturestart' as any, handleGestureStart as EventListener)

window.addEventListener('unload', () => {
  document.removeEventListener('gesturestart' as any, handleGestureStart as EventListener)
})

export default app
